import React from 'react'
import AdminSettingsContainer from 'containers/panel/admin/settings-container'

const SettingsPage = () => {
  return (
    <AdminSettingsContainer/>
  )
}

export default SettingsPage